export const joinInputs = (node) => {
    // console.log('joining inputs...')
    const focusableInputs = () => {
        const arr = Array.from(node.querySelectorAll('input[type="text"], input[type="number"]'))
        // console.log('focusableInputs:', arr)
        return arr
    }
    
    const getVals = () => {
        const $current = document.activeElement
        
		const inputs = focusableInputs()
		const $first = inputs.at(0)
		const $last = inputs.at(-1)
        
        const currentInputIndex = inputs.indexOf($current)
        
        // console.log('getVals:', [$current, inputs, $first, $last, currentInputIndex])
        return [$current, inputs, $first, $last, currentInputIndex]
    }

    const handleKeyup = (e) => {
        // console.log('handleKeyup')
        // console.log('e.key', e.key)
        
        if ( 
            [
                'Tab',
                'Shift',
                'ArrowUp',
                'ArrowDown'
            ].includes(e.key)
        ) {
            // console.log('handleKeyup aborted.')
            return
        }

        const [$current, inputs, $first, $last, currentInputIndex] = getVals()
        
        switch (e.key) {
            case 'ArrowLeft':
                // console.log('handleKeyup::ArrowLeft')
                if (
                    $current !== $first 
                 && $current.selectionStart == 0
                ) {
                    inputs[currentInputIndex-1].focus()
                }
                break
            case 'ArrowRight':
                // console.log('handleKeyup::ArrowRight')
                if (
                    $current !== $last 
                 && $current.selectionEnd == $current.value.length
                ) {
                    inputs[currentInputIndex+1].focus()
                }
                break
            default:
                // console.log('handleKeyup::default')
                if (
                    $current.value.length == $current.maxLength 
                 && $current.selectionEnd == $current.value.length
                 && $current !== $last
                ) {
                    // && !['Tab','Shift','ArrowUp','ArrowDown'].includes(e.key)
                    inputs[currentInputIndex+1].focus()
                }
        }
    }

    const handleKeydown = (e) => {
        // console.log('handleKeydown')
        // console.log('e.key', e.key)
        if ([
                'Tab', 
                'Shift',
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight'
                ,'Delete'
            ].includes(e.key)
        ) {
            // console.log('handleKeydown aborted.')
            return
        }

        const [$current, inputs, $first, $last, currentInputIndex] = getVals()

        switch (e.key) {
            case 'Backspace':
                // console.log('handleKeydown::Backspace')
                if ($current !== $first
                 && $current.selectionStart == 0
                 && $current.selectionEnd == 0
                ) {
                    inputs[currentInputIndex-1].focus()
                }
                break
            case 'Home':
                // console.log('handleKeydown::Home')
                $first.focus()
                break
            case 'End':
                // console.log('handleKeydown::End')
                $last.focus()
                break
            default:
                // console.log('handleKeydown::default')
                if ($current.value.length == $current.maxLength
                 && !['Backspace','Home','End'].includes(e.key)
                ) {
                    e.stopPropagation()
                    e.preventDefault()
                }
        }
    }

    node.addEventListener('keydown', handleKeydown)
    node.addEventListener('keyup', handleKeyup)

    return {
        destroy() {
            node.removeEventListener('keydown', handleKeydown)
            node.removeEventListener('keyup', handleKeyup)
            return null
        }
    }
}